import React, { FC } from 'react';
import styled from 'styled-components';
import { InputError } from './InputError';
import { Label } from './Label';
import { Input } from './Input';
import { Context } from './Context';

interface Props {
  name: string;
}
const Wrapper = styled.div``;

const FormItemBase: FC<Props> = ({ name, children, ...props }) => {
  return (
    <Context.Provider value={{ name }}>
      <Wrapper {...props}>{children}</Wrapper>
    </Context.Provider>
  );
};

export const FormItem = Object.assign(FormItemBase, {
  Error: InputError,
  Label,
  Input,
});
try {
    // @ts-ignore
    FormItem.displayName = "FormItem";
    // @ts-ignore
    FormItem.__docgenInfo = { "description": "", "displayName": "FormItem", "props": { "name": { "defaultValue": null, "description": "", "name": "name", "required": true, "type": { "name": "string" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/FormItem/FormItem.tsx#FormItem"] = { docgenInfo: FormItem.__docgenInfo, name: "FormItem", path: "src/components/FormItem/FormItem.tsx#FormItem" };
}
catch (__react_docgen_typescript_loader_error) { }